import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText
} from "@material-ui/core";

import { closeContributorModal } from "../../actions/modalActions";

import "../../styles/processModal.scss";

class ContributorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeContributorModal();
    }
  };

  render() {
    const actions = [
      <Button color="secondary" onClick={this.handleClose}>
        Close
      </Button>
    ];

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Credits</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The idea for this periodic table with materials etched by ALE came from the periodic table with {" "}
          <a href="https://atomiclimits.com/alddatabase/">ALD-prepared materials</a> building on earlier work by <b>Riikka Puurunen</b>.
            <br /> <br />
            The initiative for this online database was taken by{" "}
            <b>Tahsin Faraz</b>, <b>Harm Knoops</b>, <b>Bart Macco</b>, <b>Adrie Mackus</b>,  <b>Vincent Vandalon</b>, and{" "}
            <b>Erwin Kessels</b>. New submissions and comments will be reviewed by <b>Nick Chittock</b>,{" "}
               <b>Tahsin Faraz</b> and <b>Adrie Mackus</b> aiming for a weekly
               update of the database. <b>Erwin Kessels</b> is responsible for the overall management. Queries
               and questions can be submitted to <a href="email:info@atomiclimits.com">info@atomiclimits.com</a>.
            <br /> <br />
            <b>Jan Buiter</b> designed the website and took care of the
            programming.
            <br /> <br />
            In addition to the people above, we would like to thank the
            following persons for contributing significantly to the contents of
            this database: (Your name can appear here if you add materials,
            processes or references (See “About this periodic table” and “Add
            process” button in the menu.))
            <br />
            <br />
            {this.props.contributors
              .filter(
                contributor =>
                  ![
                    "",
                    "Jan Buiter",
                    "Harm Knoops",
                    "Bart Macco",
                    "Vincent Vandalon"
                  ].includes(contributor.name)
              )
              .map(contributor => (
                <>
                  <b>{contributor.name}</b>: {contributor.number}{" "}
                  {contributor.number > 1 ? "contributions" : "contribution"}
                  <br />
                </>
              ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: state.modal.contributorModalIsOpen,
    contributors: state.process.contributors,
    modalOpenTime: state.modal.modalOpenTime
  };
}

export default connect(
  mapStateToProps,
  { closeContributorModal }
)(ContributorModal);
